import { ApolloError } from '@apollo/client';
import { Alert, AlertTitle } from '@mui/material';
import { i18n } from '@modernloop/i18n';
import { AxiosError } from 'axios';
import { z } from 'zod';

const errorMessageSchema = z.object({ message: z.string() });
const stringSchema = z.string();

const getErrorMessage = (cause?: unknown): string | null => {
  if (!cause) {
    return null;
  }

  const parsedStringError = stringSchema.safeParse(cause);
  if (parsedStringError.success) {
    return parsedStringError.data;
  }

  if (cause instanceof ApolloError) {
    if (cause?.cause?.message) {
      return cause?.cause?.message;
    }
  }

  if (cause instanceof AxiosError) {
    return cause?.message;
  }

  if (cause instanceof Error) {
    return cause?.message;
  }

  const parsedError = errorMessageSchema.safeParse(cause);
  if (parsedError.success) {
    return parsedError.data.message;
  }

  return i18n.t('common:shared.error.badRequest');
};

type PublicErrorProps = {
  error?: unknown;
  errorTitle?: string;
};

export const PublicError = ({ error, errorTitle }: PublicErrorProps): JSX.Element | null => {
  const errorMsg = getErrorMessage(error);
  if (!errorMsg) {
    return null;
  }

  return (
    <Alert severity="error">
      <AlertTitle>{errorTitle}</AlertTitle>
      {errorMsg}
    </Alert>
  );
};
